import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/bronze_horseman.png'
import _imports_1 from '@/assets/svg/account_balance.svg'
import _imports_2 from '@/assets/svg/union.svg'
import _imports_3 from '@/assets/svg/safety.svg'
import _imports_4 from '@/assets/svg/credibility.svg'
import _imports_5 from '@/assets/images/tourism.png'
import _imports_6 from '@/assets/images/league_second.png'


const _withScopeId = n => (_pushScopeId("data-v-92ba9504"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-10 py-[92px]" }
const _hoisted_2 = { class: "flex flex-col items-center mb-12" }
const _hoisted_3 = { class: "px-[22px] mb-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_5 = { class: "flex flex-col gap-y-6 px-10 mb-10" }
const _hoisted_6 = { class: "flex items-center gap-x-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-7 h-7"
}, null, -1))
const _hoisted_8 = { class: "grid grid-cols-[12px_auto] gap-x-2 items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-3 w-3 bg-[var(--secondary-color)] rounded-full" }, null, -1))
const _hoisted_10 = { class: "flex items-center gap-x-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-7 h-7"
}, null, -1))
const _hoisted_12 = { class: "grid grid-cols-[12px_auto] gap-x-2 items-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-3 w-3 bg-[var(--secondary-color)] rounded-full" }, null, -1))
const _hoisted_14 = { class: "flex items-center gap-x-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "w-7 h-7"
}, null, -1))
const _hoisted_16 = { class: "grid grid-cols-[12px_auto] gap-x-2 items-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-3 w-3 bg-[var(--secondary-color)] rounded-full" }, null, -1))
const _hoisted_18 = { class: "flex items-center gap-x-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "w-7 h-7"
}, null, -1))
const _hoisted_20 = { class: "grid grid-cols-[12px_auto] gap-x-2 items-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-3 w-3 bg-[var(--secondary-color)] rounded-full" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex gap-x-1 items-center justify-center px-10 mb-10" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_5 })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_6 })
  ])
], -1))
const _hoisted_23 = { class: "flex items-center justify-center px-10" }

import BaseButton from '@/components/common/BaseButton.vue';
import BaseTypography from '@/components/common/BaseTypography.vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SecondSection',
  setup(__props) {

const { t } = useI18n();

const router = useRouter();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(BaseButton, {
          text: _unref(t)('main-page.about.title'),
          type: "subtitle-m",
          "padding-x": "24",
          "padding-y": "12",
          color: "var(--black-color)",
          ui: "primary"
        }, null, 8, ["text"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createVNode(BaseTypography, {
            text: _unref(t)('main-page.about.subtext.text-1.first'),
            type: "subtitle-m",
            color: "var(--black-color)",
            tag: "span"
          }, null, 8, ["text"]),
          _createVNode(BaseTypography, {
            text: _unref(t)('main-page.about.subtext.text-1.second'),
            type: "subtitle2-m",
            color: "var(--black-color)",
            tag: "span"
          }, null, 8, ["text"])
        ]),
        _createVNode(BaseTypography, {
          text: _unref(t)('main-page.about.subtext.text-2'),
          type: "subtitle2-m",
          color: "var(--black-color)"
        }, null, 8, ["text"]),
        _createVNode(BaseTypography, {
          text: _unref(t)('main-page.about.subtext.text-3'),
          type: "subtitle2-m",
          color: "var(--black-color)"
        }, null, 8, ["text"])
      ]),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(BaseTypography, {
            text: _unref(t)('main-page.about.register'),
            type: "body-m"
          }, null, 8, ["text"])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(BaseTypography, {
            text: _unref(t)('main-page.about.league'),
            type: "body-m"
          }, null, 8, ["text"])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(BaseTypography, {
            text: _unref(t)('main-page.about.safety'),
            type: "body-m"
          }, null, 8, ["text"])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createVNode(BaseTypography, {
            text: _unref(t)('main-page.about.credibility'),
            type: "body-m"
          }, null, 8, ["text"])
        ])
      ])
    ]),
    _hoisted_22,
    _createElementVNode("div", _hoisted_23, [
      _createVNode(BaseButton, {
        text: _unref(t)('main-page.about.more'),
        type: "subtitle4-m",
        color: "var(--base-white)",
        "padding-x": "84",
        "padding-y": "18",
        ui: "green",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/about')))
      }, null, 8, ["text"])
    ])
  ], 64))
}
}

})